import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { setPayPeriod, clearFilters } from "../../redux/features/timecard/EmpTimecardFilterSlice";
import { ChevronLeft, CirclePlus } from "lucide-react";

const TimecardFilter: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { payPeriod } = useSelector((state: RootState) => state.EmpTimecardFilter);

    return (
        <div className="min-h-screen w-full max-w-md mx-auto bg-white">
            {/* Header */}
            <div className="bg-white p-4 flex items-center justify-between text-black">
                <button onClick={() => navigate(-1)}>
                    {/* <IoMdArrowBack size={24} /> */}
                    <ChevronLeft size={24} />
                </button>
                <span className="text-lg font-semibold">Filters</span>
                <button onClick={() => dispatch(clearFilters())} className="text-black font-medium">
                    Clear
                </button>
            </div>

            <div className="p-4 space-y-6">
                <div className="flex items-center justify-between">
                    <label className="text-gray-700 text-base">Payperiod</label>
                    <select
                        aria-label="Payperiod"
                        value={payPeriod}
                        onChange={(e) => {
                            if (e.target.value === "Custom-Payperiod") {
                                const dateInput = document.createElement("input");
                                dateInput.type = "date";
                                dateInput.onchange = (event) =>
                                    dispatch(setPayPeriod((event.target as HTMLInputElement).value));
                                dateInput.click();
                            } else {
                                dispatch(setPayPeriod(e.target.value));
                            }
                        }}
                        className="border rounded p-2 text-gray-700 w-1/2"
                    >
                        <option>Feb 10 - Feb 16</option>
                        <option>Feb 03 - Feb 09</option>
                        <option>Jan 27 - Feb 03</option>
                        <option>Jan 20 - Jan 26</option>
                        <option>Jan 13 - Jan 19</option>
                        <option>Custom-Payperiod</option>
                    </select>
                </div>
                <div className="flex items-center justify-between">
                    <label className="text-gray-700 text-base">Site</label>
                    <button onClick={() => navigate("/test-FilterSelectSite")}>
                        {/* <IoAddCircleOutline size={28} className="text-[#2196F3]" /> */}
                        <CirclePlus size={28} className="text-[#2196F3]" />
                    </button>
                </div>
            </div>

            {/* Apply Button */}
            <div className="p-4">
                <button className="w-full bg-[#2196F3] text-white font-bold py-2 rounded">APPLY</button>
            </div>
        </div>
    );
};

export default TimecardFilter;
